import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { AppointmentType } from './appointment-type.interface';

export class AppointmentTypeService {
   async getAppointmentTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<AppointmentType>>>(`/appointment-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
